<template>
  <el-dialog
    width="450px"
    class="cus-alert-dialog-cls"
    :visible="visible"
    :show-close="false"
    @close="handleClose"
    top="30vh"
  >
    <div class="my-cotent">
      <div class="top-area">
        <div class="left-box">
          <img :src="iconwarning" />
        </div>
        <div class="right-box">
          <div class="f1">请确认删除操作</div>
          <div class="f2">删除操作不可逆，请确认操作</div>
        </div>
      </div>
      <div class="btn-area">
        <div
          class="fg-btn fg-btn-middle fg-btn-default"
          @click="
            () => {
              visible = false;
            }
          "
        >
          取消
        </div>
        <div class="fg-btn fg-btn-middle fg-btn-danger" @click="handleConfirm">
          删除
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import iconwarning from '@/asset/ICON_26.png';
import { close } from './index';
export default {
  data() {
    return {
      visible: true,
      iconwarning
    };
  },
  methods: {
    handleClose() {
      this.visible = false;
    },
    handleConfirm() {
      this.deleteFn && this.deleteFn();
      close();
    }
  }
};
</script>

<style lang="less" scoped>
.f1 {
  color: #444444;
  font-weight: bold;
  font-size: 19px;
}
.f2 {
  color: #888888;
  font-size: 16px;
  margin-top: 5px;
}
.top-area {
  display: flex;
  .left-box {
    margin-top: 64px;
    margin-bottom: 55px;
    margin-left: 61px;
    margin-right: 37px;
    img {
      display: flex;
      height: 62px;
    }
  }
  .right-box {
    margin-top: 73px;
  }
}
.my-cotent {
  height: 230px;
  .btn-area {
    width: 100%;
    display: flex;
    justify-content: center;
    position: relative;
    bottom: 6px;

    & > div {
      &:nth-child(n + 1) {
        margin-left: 15px;
      }
    }
  }
}
.fg-btn-danger {
  color: #fff;
  background: linear-gradient(270deg, #ecb96a, #f45f4f);
}
</style>

<style lang="less">
.cus-alert-dialog-cls {
  .el-dialog__header {
    padding: 0;
  }
}
</style>
